import React from "react";
import { hero } from "../mock";

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      className="relative min-h-[100svh] flex items-center overflow-hidden"
    >
      {/* Background image - shifted so needle sits toward the right edge */}
      <div
        className="absolute inset-0 bg-no-repeat bg-white"
        style={{
          backgroundImage: `url(${hero.bgImage})`,
          backgroundSize: "115% auto",
          backgroundPosition: "260px 40%",
        }}
      />
      {/* Soft radial vignette for cinematic depth */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 65% 55%, transparent 0%, transparent 55%, rgba(0,0,0,0.15) 100%)",
        }}
      />
      {/* Solid white gradient fading left-to-right so the white base blends seamlessly into the image */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(to right, #ffffff 0%, #ffffff 20%, rgba(255,255,255,0.95) 35%, rgba(255,255,255,0.75) 50%, rgba(255,255,255,0.45) 65%, rgba(255,255,255,0.20) 82%, rgba(255,255,255,0) 100%)",
        }}
      />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-12 pt-32 md:pt-36 pb-20">
        <div className="max-w-5xl">
          <h1 className="font-extrabold tracking-[-0.02em] leading-[0.95] text-neutral-900 text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
            <span className="block animate-[fadeUp_0.9s_ease-out_both]">
              {hero.titleTop}
            </span>
            <span className="block mt-2 animate-[fadeUp_1.1s_ease-out_0.15s_both]">
              <span className="text-[#7B3FA7]">{hero.titleBottomPre}</span>
              {hero.titleBottomPost}
            </span>
          </h1>

          <p className="mt-8 max-w-2xl text-neutral-400 text-lg md:text-xl leading-relaxed animate-[fadeUp_1.2s_ease-out_0.35s_both]">
            {hero.description}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 animate-[fadeUp_1.3s_ease-out_0.55s_both]">
            <button
              onClick={() => scrollTo("#about")}
              className="group inline-flex items-center justify-center rounded-full bg-[#7B3FA7] px-8 py-4 text-white text-[15px] font-semibold shadow-[0_10px_24px_-8px_rgba(123,63,167,0.55)] hover:bg-[#6A2F94] hover:-translate-y-0.5 hover:shadow-[0_18px_30px_-10px_rgba(123,63,167,0.6)] transition-[transform,background-color,box-shadow] duration-300"
            >
              {hero.primaryCta}
            </button>
            <button
              onClick={() => scrollTo("#contact")}
              className="inline-flex items-center justify-center rounded-full border border-neutral-800/80 bg-transparent px-8 py-4 text-neutral-900 text-[15px] font-semibold hover:bg-neutral-900 hover:text-white hover:-translate-y-0.5 transition-[transform,background-color,color] duration-300"
            >
              {hero.secondaryCta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
